/**
 * KYS Editorial Motion Engine — RC1 Polish Pass 2
 * Calibrated viewport sequence observer for calm, intentional section arrival.
 */

(function () {
  'use strict';

  let activeObserver = null;

  function isReducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /**
   * 1. Header Scrolled State Controller
   */
  function initHeaderScrollState() {
    const header = document.querySelector('header-component');
    if (!header) return;

    let ticking = false;

    function updateHeader() {
      if (!header) return;
      const isScrolled = window.scrollY > 15;
      if (header.classList.contains('is-scrolled') !== isScrolled) {
        header.classList.toggle('is-scrolled', isScrolled);
        header.setAttribute('data-scrolled', isScrolled ? 'true' : 'false');
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateHeader();
  }

  /**
   * 2. Hero Exit & Handoff Progress Handler
   * Calculates continuous scroll progress for Hero exit into Choose Your Fit.
   */
  function initHeroHandoff() {
    if (isReducedMotion()) return;

    const hero = document.querySelector('.kys-hero');
    const heroContent = document.querySelector('.kys-hero__content');
    if (!hero || !heroContent) return;

    let ticking = false;
    const heroHeight = hero instanceof HTMLElement ? hero.offsetHeight : 600;
    const maxScrollBound = heroHeight * 1.25;

    function updateHeroExit() {
      if (!heroContent) return;
      const scrollY = window.scrollY;

      if (scrollY <= maxScrollBound) {
        const progress = Math.min(1, Math.max(0, scrollY / (heroHeight * 0.55))).toFixed(3);
        if (heroContent instanceof HTMLElement) {
          heroContent.style.setProperty('--hero-exit-progress', progress);
        }
      }

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking && window.scrollY <= maxScrollBound) {
          window.requestAnimationFrame(updateHeroExit);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateHeroExit();
  }

  /**
   * 3. Viewport Sequence Observer — RC1 Polish Pass 2 Calibrated Triggering
   * Triggers when section is comfortably in view (threshold: 0.20, rootMargin: -100px)
   */
  function initEditorialChoreography() {
    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }

    const selector =
      '.kys-fit, .kys-brand-philosophy, .kys-current-rotation, .kys-bts, .kys-reveal, .kys-related-products, .kys-collection-main, .footer, footer';
    const targets = document.querySelectorAll(selector);
    if (!targets || targets.length === 0) return;

    if (isReducedMotion()) {
      targets.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.20
    };

    activeObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    targets.forEach((target) => {
      if (target) {
        if (!target.classList.contains('kys-reveal')) {
          target.classList.add('kys-reveal');
        }
        activeObserver.observe(target);
      }
    });
  }

  function init() {
    initHeaderScrollState();
    initHeroHandoff();
    initEditorialChoreography();
  }

  /* Shopify Theme Editor Re-render Listeners */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
